import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@dadusachaar.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("da_admin_token", res.data.token);
      toast.success("Welcome back, Dadu");
      navigate("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fade-up max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="bg-white border border-[#E6DEC3] rounded-2xl p-8">
        <div className="w-12 h-12 rounded-full bg-[#9E3B21]/10 flex items-center justify-center mb-4">
          <Lock className="w-5 h-5 text-[#9E3B21]" />
        </div>
        <h1 className="font-serif text-3xl font-bold">Admin Login</h1>
        <p className="text-sm text-[#6E675F] mt-1 mb-6">Manage products, view orders, update status.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Email</Label>
            <Input data-testid="admin-login-email" type="email" className="mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="admin-login-password" type="password" className="mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary rounded-full w-full py-6">
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
